import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Landmark, HeartPulse, GraduationCap, ShoppingCart, 
  Truck, Briefcase, Building2, Home, Plane, Factory
} from 'lucide-react';
import './IndustriesPage.css';

const industries = [
  {
    icon: <Landmark size={48} />,
    name: 'FinTech',
    description: 'Secure, compliant solutions for banking, payments, and financial services.',
    projects: '50+ projects',
    features: ['Payment Processing', 'Blockchain', 'Fraud Detection', 'Investment Platforms']
  },
  {
    icon: <HeartPulse size={48} />,
    name: 'Healthcare',
    description: 'HIPAA-compliant platforms for hospitals, telemedicine, and healthtech.',
    projects: '40+ projects',
    features: ['Telemedicine', 'EHR Systems', 'Patient Portals', 'Medical IoT']
  },
  {
    icon: <GraduationCap size={48} />,
    name: 'EdTech',
    description: 'Interactive learning platforms and educational management systems.',
    projects: '35+ projects',
    features: ['LMS', 'Virtual Classrooms', 'Assessment Tools', 'Student Analytics']
  },
  {
    icon: <ShoppingCart size={48} />,
    name: 'E-commerce',
    description: 'Scalable online stores and marketplace solutions.',
    projects: '60+ projects',
    features: ['Marketplaces', 'Payment Gateway', 'Inventory Management', 'AI Recommendations']
  },
  {
    icon: <Truck size={48} />,
    name: 'Logistics',
    description: 'Route optimization, fleet management, and supply chain solutions.',
    projects: '25+ projects',
    features: ['Route Optimization', 'Fleet Tracking', 'Warehouse Management', 'Last Mile Delivery']
  },
  {
    icon: <Briefcase size={48} />,
    name: 'SaaS',
    description: 'Multi-tenant platforms and subscription-based applications.',
    projects: '45+ projects',
    features: ['Subscription Billing', 'Multi-tenancy', 'Analytics', 'API First Design']
  },
  {
    icon: <Building2 size={48} />,
    name: 'Real Estate',
    description: 'Property management, listing platforms, and virtual tours.',
    projects: '20+ projects',
    features: ['Property Listings', 'Virtual Tours', 'CRM', 'Mortgage Calculators']
  },
  {
    icon: <Home size={48} />,
    name: 'Hospitality',
    description: 'Booking systems, property management, and guest experience apps.',
    projects: '15+ projects',
    features: ['Booking Engines', 'PMS', 'Guest Apps', 'Revenue Management']
  },
  {
    icon: <Plane size={48} />,
    name: 'Travel & Tourism',
    description: 'Booking engines, itinerary planners, and travel apps.',
    projects: '18+ projects',
    features: ['Booking Systems', 'Itinerary Planners', 'Travel Portals', 'Loyalty Programs']
  },
  {
    icon: <Factory size={48} />,
    name: 'Manufacturing',
    description: 'IoT solutions, production monitoring, and supply chain optimization.',
    projects: '12+ projects',
    features: ['IoT Sensors', 'Production Monitoring', 'Predictive Maintenance', 'Quality Control']
  }
];

const IndustriesPage = () => {
  return (
    <div className="industries-page">
      <section className="industries-hero">
        <div className="container">
          <h1>Industries We <span className="blue-text">Serve</span></h1>
          <p>Deep domain expertise across multiple sectors</p>
        </div>
      </section>

      <section className="industries-grid-section section">
        <div className="container">
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card-large">
                <div className="industry-icon">{industry.icon}</div>
                <h3>{industry.name}</h3>
                <p>{industry.description}</p>
                <div className="industry-features">
                  {industry.features.slice(0, 2).map((feature, i) => (
                    <span key={i} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <span className="project-count">{industry.projects}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="industry-cta">
        <div className="container">
          <h2>Don't see your industry?</h2>
          <p>We work with businesses across all sectors. Let's discuss your specific needs.</p>
          <Link to="/contact" className="btn btn-primary">
            Talk to Our Experts
          </Link>
        </div>
      </section>
    </div>
  );
};

export default IndustriesPage;